// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 请求接口地址 如果没有配置自动获取当前网址路径
var VUE_APP_API_URL = process.env.VUE_APP_BASE_API || "".concat(location.origin);
var VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || (location.protocol === 'https' ? 'wss' : 'ws') + ':' + location.hostname;
var SettingMer = {
  // 服务器地址
  httpUrl: VUE_APP_API_URL,
  // 接口请求地址
  apiBaseURL: VUE_APP_API_URL + '/api/',
  // socket连接
  wsSocketUrl: VUE_APP_WS_URL,
  //密钥
  PK: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAo8jKuU2/N4zvyDVdvlLwUoPTW672DtbGV7Tvek1dlmaaxV4IiA2ZNIfpXfzD3ERzN9/MQii80YkmOkpDlAAPIAOHikMhhfbMqsy13tL/z9pQO5Icu6X2VfdHUdKDEOUTnD/lA0tRwu80dw/+VOkvzg7I3qDcT6gsRs9J92SN+KydMeulqk/AjZomP9/ISgz2i8gLi62jCswbCsvqg9kx7FMq4p/fHTqCXvDPt6ebEQbFh0FP2TmD/f7XISUeplD45u19yheYfPt1UvjePKZrbuHWTmB7YfNSdBv9rCREllxc/nQ6o4LB2alW7ZoGWc3PjlH1MwpTe0Q3Iopi6nT20QIDAQAB',
  // 动态密钥
  CODE_PK: ''
};
export default SettingMer;